import { getLoggedUser } from '@/helpers/storageOperations';

export default () => {
    return getLoggedUser()?.businessProfile?.timeZone || 'UTC';
};
